// import Table from "components/ui/table/Table"
import { useMemo, useState, useEffect } from "react"
import Table from "components/ui/table/Table"
import { useNotifications } from "@mantine/notifications"
import { SelectColumnFilter } from "components/ui/table/TableHeader"
import { getAll } from "services/api.service"
import { StatusPill, EntryExitCell } from "components/ui/table/TableUtils"
import useFetchAndLoad from "hooks/useFetchAndLoad.ts"

const History = () => {
  const API_ENDPOINT = "/access"

  const [accesses, setAccesses] = useState([])
  const [refresh, setRefresh] = useState(false)

  const { loading, callEndpoint } = useFetchAndLoad()
  const notifications = useNotifications()

  const statusMap = {
    0: "Pendiente",
    1: "Dentro",
    2: "Fallido",
    3: "Cerrado",
    4: "Cerrado por admin",
    5: "Denegado por guardia",
  }

  const getSupplierAccessData = (access) => {
    return {
      name: access.attempted_person
        ? `${access.attempted_person.first_name} ${access.attempted_person.last_name}`
        : "Si datos de la persona",

      status: statusMap[access.status],
      role: "Proveedor",
      entry: {
        date: access.attempted_at,
        time: new Date(access.attempted_at).toLocaleTimeString(),
      },

      exit: {
        date: access.closed_at,
        time: new Date(access.attempted_at).toLocaleTimeString(),
      },
      worksite: access.attempted_location ? access.attempted_location.name : "Sin obra",
      hasEquipment: access.hasEquipment ? "Si" : "No",
    }
  }
  const getEmployeeAccessData = (access) => {
    return {
      name: `${access.attempted_by.first_name} ${access.attempted_by.last_name_1} ${access.attempted_by.last_name_2}`,
      status: statusMap[access.status],
      role: "Empleado",
      entry: {
        date: access.attempted_at,
        time: new Date(access.attempted_at).toLocaleTimeString(),
      },

      exit: {
        date: access.closed_at,
        time: new Date(access.attempted_at).toLocaleTimeString(),
      },
      worksite: access.attempted_location ? access.attempted_location.name : "Sin obra",
      hasEquipment: access.hasEquipment ? "Si" : "No",
    }
  }
  const getContractorEmployeeAccessData = (access) => {
    return {
      name: `${access.attempted_by.first_name} ${access.attempted_by.last_name_1} ${access.attempted_by.last_name_2}`,
      status: statusMap[access.status],
      role: "Contratista",
      entry: {
        date: access.attempted_at,
        time: new Date(access.attempted_at).toLocaleTimeString(),
      },

      exit: {
        date: access.closed_at,
        time: new Date(access.attempted_at).toLocaleTimeString(),
      },
      worksite: access.attempted_location ? access.attempted_location.name : "Sin obra",
      hasEquipment: access.hasEquipment ? "Si" : "No",
    }
  }

  const adaptAccessData = (access) => {
    const attemptedByDictionary = {
      Supplier: getSupplierAccessData,
      Employee: getEmployeeAccessData,
      ContractorEmployee: getContractorEmployeeAccessData,
    }

    return attemptedByDictionary[access.attempted_by_model](access)
  }

  const setData = async () => {
    await callEndpoint(getAll(API_ENDPOINT))
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setAccesses(response.data.data.map((access) => adaptAccessData(access)))
        }
      })
      .catch((error) => {
        console.log(error)
        notifications.showNotification({
          color: "red",
          title: "Error",
          message: "Error al obtener el historial de accesos",
        })
      })
  }

  useEffect(() => {
    setData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  const columns = useMemo(
    () => [
      {
        Header: "Nombre",
        accessor: "name",
      },

      {
        Header: "Rol",
        accessor: "role",
        Filter: SelectColumnFilter,
        filter: "includes",
      },

      {
        Header: "Entrada",
        accessor: "entry",
        Cell: ({ row }) => <EntryExitCell value={row.original.entry}></EntryExitCell>,
      },

      {
        Header: "Salida",
        accessor: "exit",
        Cell: ({ row }) => <EntryExitCell value={row.original.exit}></EntryExitCell>,
      },

      {
        Header: "Obra",
        accessor: "worksite",
        Filter: SelectColumnFilter,
        filter: "includes",
      },

      {
        Header: "Con equipamento",
        accessor: "hasEquipment",
        Filter: SelectColumnFilter,
        filter: "includes",
      },

      {
        Header: "Status",
        accessor: "status",
        Filter: SelectColumnFilter,
        filter: "includes",
        Cell: StatusPill,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setData]
  )

  return (
    <>
      <Table
        columns={columns}
        data={accesses}
        iconName={"date_range"}
        loading={loading}
        header={"Historial de accesos"}
        isAccessesTab={true}
        refreshData={() => setRefresh(!refresh)}
      />
    </>
  )
}

export default History
